import { InjectionToken } from "@angular/core";
import { AddressDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export abstract class IAddressAddDialogService {

  abstract addressAddDialogShow(
    modalTitle: string,
    addressTemplate: AddressDto | undefined,
    callbackSubmit: (result: AddressDto) => void,
    callbackCancel: () => void,
    submitButtonLabel?: string,
    cancelButtonLabel?: string,
  ): unknown;

}
/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IAddressAddDialogServiceToken = new InjectionToken<IAddressAddDialogService>('IAddressAddDialogServiceToken');
